const { getAxiosInstance } = require('../connection');

module.exports = {
    fetchActiveSessions: function () {
        return getAxiosInstance({
            url:  '/chats?include_direct=true',
            method: 'get',
        }).then((r) => r.data);
    },
    fetchMessages: function (chatId) {
        return getAxiosInstance({
            url:  '/chats/' + encodeURIComponent(chatId) + '/messages',
            method: 'get',
        }).then((r) => r.data);
    },

    postMessage: function (message, partnerId, eventId) {
        return getAxiosInstance({
            url: `/chats/messages`,
            method: 'post',
            data: {
                message,
                partnerId,
                eventId,
            },
        }).then((r) => r.data);
    },
    markAllAsRead: function (chatId) {
        return getAxiosInstance({
            url:  '/chats/' + encodeURIComponent(chatId) + '/read',
            method: 'post',
            json: true,
            data: {},
        }).then((r) => r.data);
    },
};
